<template>
  <div class="complaint-wrapper">
    <h2>投诉列表</h2>
    <el-table :data="complaints" border style="width: 100%">
      <el-table-column prop="userId" label="用户ID" width="100" />
      <el-table-column prop="nickname" label="用户昵称" width="120" />
      <el-table-column prop="reason" label="投诉原因" min-width="200" />
      <el-table-column prop="bookName" label="书籍名称" width="150" />
      <el-table-column prop="wechat" label="联系方式(微信)" width="140" />
      <el-table-column prop="qq" label="联系方式(QQ)" width="140" />
      <el-table-column label="相关截图" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.screenshots && scope.row.screenshots.length > 0">
            <el-image
              v-for="(img, index) in scope.row.screenshots"
              :key="index"
              :src="img"
              :preview-src-list="scope.row.screenshots"
              style="width: 50px; height: 50px; margin-right: 5px; cursor: pointer;"
              fit="cover"
            />
          </div>
          <span v-else style="color: #999;">暂无截图</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

interface Complaint {
  userId: number
  nickname: string
  reason: string
  bookName: string
  wechat: string
  qq: string
  screenshots: string[]
}

@Component
export default class ComplaintList extends Vue {
  complaints: Complaint[] = [
    {
      userId: 262,
      nickname: '小明同学',
      reason: '这个立绘是用的别的游戏的',
      bookName: '逃离病娇，理解病娇，占有病娇',
      wechat: 'xiaoming_2024',
      qq: '382859285',
      screenshots: [
        'https://picsum.photos/200/200?random=1',
        'https://picsum.photos/200/200?random=2'
      ]
    },
    {
      userId: 268,
      nickname: '爱读书的猫',
      reason: '这个剧情好像在别的地方看到过',
      bookName: '逃离病娇，理解病娇，占有病娇',
      wechat: 'cat_reader',
      qq: '477582674',
      screenshots: [
        'https://picsum.photos/200/200?random=3'
      ]
    },
    {
      userId: 355,
      nickname: '夜晚的星空',
      reason: '涉嫌辱骂，我不爽',
      bookName: '逃离病娇，理解病娇，占有病娇',
      wechat: 'night_star_99',
      qq: '358298638',
      screenshots: []
    }
  ]
}
</script>

<style scoped>
.complaint-wrapper {
  padding: 20px;
}

h2 {
  margin-bottom: 20px;
  color: #303133;
}
</style>
